<ng-container *ngIf="!!segmentedControl">
  <div
    class="btn-group w-100"
    data-test="segmented-control">
    <ng-container *ngIf="segmentedControl?.options?.[0]?.type === 'link' else filterOption">
        <a *ngFor="let option of segmentedControl.options; trackBy: trackById"
        class="btn px-2 px-sm-4"
        (click)="handleClick(option)"
        [ngClass]="{'active': option.state === 'selected'}"
        [floCustomLink]="option.url"
        floAnalytics
        [analyticsProperties]="option.analytics"
        tagName="Button"
      >
        {{option.title}}
    </a>
    </ng-container>
    <ng-template #filterOption>
      <a  *ngFor="let option of segmentedControl.options; trackBy: trackById"
      class="btn px-2 px-sm-4"
      [ngClass]="{'active': option.isSelected}"
      (click)="handleClick(option)"
      floAnalytics
      [elementName]="option.title"
      [analyticsProperties]="option.action?.analytics"
      tagName="Button"
    >
     {{ option.title }}
    </a>
    </ng-template>
  </div>
</ng-container>
